import { debounce } from './toolkit'

const calculateAndSetOffset = (headerSelector: string, cssVariable: string) => {
  const header = document.querySelector(headerSelector)
  const announcement = document.querySelector(
    '#shopify-section-announcement-bar'
  )

  const headerHeight = header?.getBoundingClientRect().height || 0
  const announcementHeight = announcement?.getBoundingClientRect().height || 0
  const totalOffset = headerHeight + announcementHeight

  document.documentElement.style.setProperty(cssVariable, `${totalOffset}px`)

  return totalOffset
}

const handleLayout = () => {
  if (Pura?.isInApp) {
    calculateAndSetOffset('.app-header', '--header-offset-app')
    document.body.classList.add('in-app')
  } else {
    calculateAndSetOffset(
      '.shopify-section-group-header-group',
      '--header-offset'
    )
  }
}

handleLayout()
window.addEventListener('resize', debounce(handleLayout, 250))
